import React, { useEffect, useState } from "react";
import { Card, CardBody, CardFooter, CardTitle, Row, Col } from "reactstrap";

import LineChart from "./InspectionChart.js";
import PieChart from "./_chart2.js";
import LineChart2 from "./_chart3.js";
import { BASE_URL } from "../../constants.js";

function Dashboard() {
  const [propertyCount, setPropertyCount] = useState(0);
  const [inspectionCount, setInspectionCount] = useState(0);
  const [tenantCount, setTenantCount] = useState(0);
  const [usersCount, setUsersCount] = useState(0);

  console.log(propertyCount,inspectionCount,tenantCount,usersCount,'count')
  useEffect(() => {
    fetchPropertyData();
    fetchInspectionData();
    fetchTenantData();
    fetchUsersData();
  }, []);

  const fetchUsersData = () => {
    const token = localStorage.getItem('token');
    if (token) {
        fetch(`${BASE_URL}/user/list`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then(response => response.json())
            .then(data => {
                console.log(data, 'data');
                if (data.status) {
                    setUsersCount(data.result.meta_info.total_results);
                } else {
                    console.error("Error: Unable to fetch users data.");
                }
            })
            .catch(error => console.error("Error fetching data:", error));
    } else {
        console.error("Error: Authorization token is missing.");
    }
};

  const fetchPropertyData = () => {
    const token = localStorage.getItem('token');
    if (token) {
      fetch(`${BASE_URL}/property/list`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
        .then(response => response.json())
        .then(data => {
          console.log(data, 'data');
          if (data.status) {
            setPropertyCount(data.result.meta_info.total_results);
          } else {
            console.error("Error: Unable to fetch property data.");
          }
        })
        .catch(error => console.error("Error fetching data:", error));
    } else {
      console.error("Error: Authorization token is missing.");
    }
  };

  const fetchInspectionData = () => {
    const token = localStorage.getItem('token');
    if (token) {
      fetch(`${BASE_URL}/inspection`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
        .then(response => response.json())
        .then(data => {
          console.log(data, 'inspectiondata');
          if (data.status) {
            setInspectionCount(data.result.meta_info.total_results);
          } else {
            console.error("Error: Unable to fetch inspection data.");
          }
        })
        .catch(error => console.error("Error fetching data:", error));
    } else {
      console.error("Error: Authorization token is missing.");
    }
  };

  const fetchTenantData = () => {
    const token = localStorage.getItem('token');
    if (token) {
        fetch(`${BASE_URL}/tenant/list`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then(response => response.json())
            .then(data => {
                if (data.status) {
                    
                  setTenantCount(data.result.meta_info.total_results);
                } else {
                    console.error("Error: Unable to fetch renters data.");
                }
            })
            .catch(error => console.error("Error fetching data:", error));
    } else {
        console.error("Error: Authorization token is missing.");
    }
};

  return (
    <>
      <div className="content">
        <Row>
          <Col lg="3" md="6" sm="6">
            <Card className="card-stats">
              <CardBody style={{paddingBottom: '30px'}}>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-bank text-brand" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Properties</p>
                      <CardTitle tag="p">{propertyCount}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              {/* <CardFooter>
                <hr />
                <div className="stats">
                  <i className="fas fa-sync-alt" /> Update Now
                </div>
              </CardFooter> */}
            </Card>
          </Col>
          <Col lg="3" md="6" sm="6">
            <Card className="card-stats">
              <CardBody style={{paddingBottom: '30px'}}>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-badge text-brand" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Renters</p>
                      <CardTitle tag="p">{tenantCount}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              {/* <CardFooter>
                <hr />
                <div className="stats">
                  <i className="far fa-calendar" /> Last day
                </div>
              </CardFooter> */}
            </Card>
          </Col>
          <Col lg="3" md="6" sm="6">
            <Card className="card-stats">
              <CardBody style={{paddingBottom: '30px'}}>
                <Row>
                  <Col md="4" xs="5">
                  <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-single-02 text-brand" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Users</p>
                      <CardTitle tag="p">{usersCount}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              {/* <CardFooter>
                <hr />
                <div className="stats">
                  <i className="far fa-clock" /> In the last hour
                </div>
              </CardFooter> */}
            </Card>
          </Col>
          <Col lg="3" md="6" sm="6">
            <Card className="card-stats">
              <CardBody style={{paddingBottom: '30px'}}>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-check-2 text-brand" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Inspections</p>
                      <CardTitle tag="p">{inspectionCount}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              {/* <CardFooter>
                <hr />
                <div className="stats">
                  <i className="fas fa-sync-alt" /> Update now
                </div>
              </CardFooter> */}
            </Card>
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <LineChart />
          </Col>
        </Row>
        {/* <Row>
          <Col md="4">
            <PieChart />
          </Col>
          <Col md="8">
            <LineChart2 />
          </Col>
        </Row> */}
      </div>
    </>
  );
}

export default Dashboard;
